export let oneData = [
  {
    url: require("./img/组 41@2x.png"),
    title: "数据聚合",
    text: "全厂作业无纸化 数据实时自动汇总 智能终端，聚合数据"
  },
  {
    url: require("./img/组 42@2x.png"),
    title: "实时监控",
    text: "实时把控生产进度 生产异常及时报警 层级信息实时传递"
  },
  {
    url: require("./img/组 45@2x.png"),
    title: "分析解读",
    text: "数据可视化呈现 多维度数据解读 各层级自助分析"
  },
  {
    url: require("./img/路径 46@2x.png"),
    title: "智能决策",
    text: "自动计算产能 智能生产排期 智能规划库存"
  }
];

export let coreData = [
  {
    url: require("./img/矩形 34@2x.png"),
    title: "智能排期",
    text:
      "1、柔性规划生产全盘掌握生产信息，辅助柔性排期  2、智能推荐排程方案云计算推荐排程方案，智能优化生产管理 3、实时掌握生产进度精确到任务，实时更新订单计划情况和生产进度，生产数据可视化"
  },
  {
    url: require("./img/图像 18@2x.png"),
    title: "生产管理",
    text:
      "1、可视化计划排程，实时掌握生产进度和异常 2、移动端扫码领取任务，完成实时报工 3、支持现场数据看板和远程监控，质量管理"
  },
  {
    url: require("./img/矩形 35@2x.png"),
    title: "质量管理",
    text:
      "1、自定义多类型质检方案，实时了解现场质检结果 2、支持走动式质检，结果随时拍照上传；质检报告扫码绑定生产批次 3、远程监控生产质量，快速追溯质量源头"
  },
  {
    url: require("./img/矩形 36@2x.png"),
    title: "物料管理",
    text:
      "1、实时查看制品库存，出入库记录明细 2、扫码追溯生产履历和用料批次，锁定问题源头改进制造过程 3、实时展示库存波动和库存水位，提升库存利用率和周转效率"
  },
  {
    url: require("./img/矩形 37@2x.png"),
    title: "设备维护",
    text:
      "1、根据设备实际维护数据，灵活配置维保计划，在线管理设备台账 2、移动端推送设备维护任务，缩短产线停线时间 3、实时记录设备运转效率，进行预测性维护"
  },
  {
    url: require("./img/矩形 38@2x.png"),
    title: "工艺路线",
    text:
      "1、工艺路线与物料结合管控，更精确，支持多版本历史记录管理 2、移动端随时查看工艺路线维护的信息、图纸和文档 3、支持并行工序，适应现场柔性排产"
  },
  {
    url: require("./img/矩形 39@2x.png"),
    title: "统计分析",
    text:
      "1、全方位根据工厂运转方式建模，量身定制工厂模型 2、灵活根据工厂变化更改配置，分毫不差指导生产 3、支持历史版本管理"
  },
  {
    url: require("./img/矩形 40@2x.png"),
    title: "商业智能",
    text:
      "1、高效利用沉淀数据，可视化实时呈现复杂信息 2、无需具备编程知识，简单拖拽，即可对数据做任意维度的分析 3、通过数据获得业务洞察，各层级业务人员都能自助分析数据"
  }
];

export let advantageData = [
  {
    url: require("./img/组 67@2x.png"),
    title: "财务管理",
    text: "在强健的财务管理中融入内置商务智能，从而更智慧、更快速地做出决策。"
  },{
    url: require("./img/路径 49@2x.png"),
    title: "多端口应用",
    text: "将销售、财务及履行流程与定价、销售订单管理和退货管理功能相关联，从而加快“订单到收款”流程。"
  },{
    url: require("./img/组 70@2x.png"),
    title: "生产管理",
    text: "实时洞察生产管理流程，从而将您的产品快速、高效地推向市场。"
  },{
    url: require("./img/路径 65@2x.png"),
    title: "供应链管理",
    text: "从一个协作平台来定义、执行和支持供应链/分销管理计划。"
  },{
    url: require("./img/组 71@2x.png"),
    title: "仓储管理",
    text: "实时管理端到端的库存和入库/出库物流，同时显著降低总拥有成本。"
  },{
    url: require("./img/组 74@2x.png"),
    title: "采购",
    text: "提高采购到付款流程的准确度，增强成本控制。"
  }
];



// WEBPACK FOOTER //
// ./src/view/erpManage/testData.js